// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__-lKmL"};